<form #form="ngForm" (ngSubmit)="submit()">
    <h2 mat-dialog-title [translate]="'programResults_lblNotificationCode'"></h2>
    <mat-dialog-content>
        <app-application-notes
            [applicationId]="applicationId"
            [position]="'ProgramResult'"
            [single]="true"
            [canEdit]="false"
            [notes]="notes">
        </app-application-notes>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button type="submit" color="primary">{{'ok' | translate}}</button>
    </mat-dialog-actions>
</form>
